
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/developers/homepage-takeover",
      function () {
        return require("private-next-pages/products/developers/homepage-takeover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/developers/homepage-takeover"])
      });
    }
  